/**
 * Display EU Checkout warning if price > £110 and user is in EU
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

import { euCountries } from '../../util/euCountryList';

const euCheckoutWarning = () => {
    const checkoutButtonDrawer = document.getElementById('CartDrawer-Checkout');
    const checkoutCartButton = document.getElementById('checkout');
    const checkoutButtons = [checkoutButtonDrawer, checkoutCartButton];
    if (!checkoutButtonDrawer && !checkoutCartButton) return;

    checkoutButtons.map((checkoutButton) => {
        checkoutButton?.addEventListener('click', (e) => {
            const userCountry = localStorage.getItem('user_country');
            let isInEu = false;
            if (userCountry) {
                if (euCountries.includes(userCountry) || userCountry === 'EU') {
                    isInEu = true;
                }
            } else {
                fetch('https://api.ipregistry.co/?key=u9b0sa4ypuwudqha')
                    .then((response) => response.json())
                    .then((data) => data.location.country.code)
                    .then((countryCode) => {
                        if (euCountries.includes(countryCode) || countryCode === 'EU') {
                            isInEu = true;
                        }
                    });
            }

            const preTranslatedCostContainer = document.querySelector(
                '.totals__subtotal-value.skiptranslate.notranslate'
            );
            const preTranslatedCost =
                preTranslatedCostContainer?.dataset.price ||
                preTranslatedCostContainer?.innerHTML.replace('£', '').replace('GBP', '').replace('.', '');
            // const currentCurrency = document.querySelector('.cbb-price-code');
            const shouldCheck = preTranslatedCost > 11000 && isInEu;
            let shouldChangePage;
            if (shouldCheck) {
                shouldChangePage = confirm(
                    '***CUSTOMS FEES***\nYour order is over £120 GBP and so it will be subject to customs fees. Here are some options:\n\n1. Choose the DHL shipping taxes and duties paid option\n\n2. Choose a different shipping option and instead pay fees when the parcel arrives in your country\n\n3. Split your order into two or more orders. If your order totals are under £120 GBP, you will not have to pay customs fees (but you will have to pay for shipping more than once)'
                );
            }

            if (!shouldChangePage && shouldCheck) {
                e.preventDefault();
            }
        });
    });
};

export default euCheckoutWarning;
